<template>
  <div
    class='device_list pr'
    ref='deviceListBox'>
    <div class='table_box'>
      <el-table
        :data="deviceList"
        :empty-text="$t('lang.noData')"
        border
        ref='topicTable'
        row-key="peerId"
        style="width:100%"
        :expand-row-keys="expands"
        @row-click='expandDetail'
        @header-dragend='setBehavior'>
        <el-table-column
          type="expand"
          width="10">
          <template slot-scope="">
            <div
              class='video_detail'
              :class='{show:expands.length}'>
              <component
                :is='receiverInfoWrap'
                :testVal='expands'
                class="source-list-box"
                :checkSourceIdFlag='true'
                v-if="receiverInfoWrap"
                pn="hm"/>
            </div>
          </template>
        </el-table-column>
        <!-- 列 -->
        <el-table-column
          width="35"
          label=""
          class-name='pink'>
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              popper-class="pinkBox"
              placement="top-start">
              <div
                slot="content"
                v-if="scope.row.pinked">{{ $t('lang.Untop') }}</div>
              <div
                slot="content"
                v-else>
                {{ $t('lang.Top') }}(<span
                  class="pinkedNum"
                  :class="pinkedNum >= pinnedDevicesNum? 'maxNum' : ''">{{ pinkedNum }}</span>
                <span :class="pinkedNum >= pinnedDevicesNum? 'maxNum' : ''">/{{ pinnedDevicesNum }}</span>)</div>
              <span
                class="iconfont pinkIcon icon-pin"
                :class="{'icon-a-pinon': scope.row.pinked, 'disabled': pinkedNum >= pinnedDevicesNum && !scope.row.pinked }"
                @click.stop="setSourceToTop(scope.row)">
                {{ scope.row.pink }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- titleArr 可能含空洞/脏数据（getBehavior 解析异常、splice 越界等），
             用 template v-for + v-if 跳过空元素，避免 render 阶段读取 undefined.name 崩溃（Sentry CC-3-0-UI-BE） -->
        <template v-for='(item, index) in titleArr'>
          <el-table-column
            v-if='item'
            :key='index'
            :class-name='item.name'
            :label="$t(`lang.${item.name}`)"
            :width='item.width'>
            <template slot-scope="scope">
              <!-- 无法拖拽的列 -->
              <div
                :class="[dropCol[index]]"
                v-if='dropCol[index]=="thumbnailObj"'>
                <!-- WR-323: Live 源的 R 关闭预览时，列表缩略图仅显隐藏预览图标 + hover 文案 [Claude Code] -->
                <div
                  v-if="rowPreviewDisabled(scope.row)"
                  class="live-preview-disabled-hint"
                  data-testid="live-preview-disabled-hint">
                  <el-tooltip
                    effect="dark"
                    placement="top"
                    popper-class="live-preview-tip"
                    :content="$t('lang.livePreviewDisabledHint')">
                    <!-- 手写 SVG 换为设计资产 iconfont，与 WebR / 设计稿视觉一致 [Claude Code] -->
                    <i class="iconfont icon-Hide lpd-icon"></i>
                  </el-tooltip>
                </div>
                <div
                  class="thumbnailIconBox"
                  :title="scope.row['peerId']"
                  :class="{'offline': scope.row.status == 0 || scope.row.status == 3}"
                  v-else-if="!scope.row.thumbnailObj || scope.row.thumbnailObj && scope.row.thumbnailObj.startsWith('icon-')">
                  <svg
                    v-if="scope.row.thumbnailObj === 'icon-a-onlinenosource'"
                    class="svg-icon"
                    aria-hidden="true">
                    <use xlink:href="#icon-a-onlinenosource"></use>
                  </svg>
                  <span
                    v-else
                    class="iconfont"
                    :class="scope.row.thumbnailObj">
                  </span>
                </div>
                <img
                  v-else-if="rowRInfoReady(scope.row)"
                  class='thumbnail_img'
                  :title="scope.row['peerId']"
                  :src="scope.row['thumbnailObj']"
                  alt=""
                  :onerror="deafultImg"
                  :style="{
                    width: '114px',
                    height: '64px',
                    objectFit: 'cover'
                  }">
                <!-- WR-323: Live 源 R 状态未到达时的中性占位，避免"在线图→禁用图标"跳转 [Claude Code] -->
                <div
                  v-else
                  class="live-preview-disabled-hint"></div>
              </div>
              <div
                :class="[dropCol[index]]"
                v-if='dropCol[index]=="source"'>
                <span
                  class='status ellipsis'
                  :class='[getStatusClass(scope.row)]'
                  :title='scope.row.source'
                  @click.stop="copyDeviceInfo($event, scope.row.source)">
                  {{ scope.row.source }}
                </span>
              </div>
              <div
                :class="[dropCol[index]]"
                v-if='dropCol[index]=="pid"'>
                <span
                  class='ellipsis'
                  :title='scope.row.peerId.toUpperCase()'
                  @click.stop="copyDeviceInfo($event, scope.row.peerId.toUpperCase())">
                  {{ scope.row.peerId.toUpperCase() }}
                </span>
              </div>
              <div
                class='r_box'
                @click='prevent($event)'
                :class="[dropCol[index]]"
                v-if='dropCol[index]=="destination"'>
                <select-source-r
                  :sourceItem="scope.row"
                  :key="scope.row.peerId"
                  :sourceListItemOps="scope.row"
                  :hadSelectDevice="isSelectNewR[scope.row.peerId]"
                  from='sourceList'
                  type="T"
                  @changeHadSelectDevice="changeHadSelectDevice"
                  @getSelectInfo="getSelectInfo"></select-source-r>
              </div>
              <!-- 可拖拽并且只有显示功能的列 -->
              <!-- 只有显示功能的列 'liveBitrate','format','typeVal','version','location' -->
              <!-- ['thumbnailObj', 'source', 'destination', 'liveBitrate', 'bitrate', 'latency', 'format', 'battery', 'bookmark', 'typeVal', 'version', 'location'] -->
              <div
                v-if='!"thumbnailObj,source,destination,battery,bookmark,bitrate,latency".includes(dropCol[index])'
                :class="[dropCol[index]]"
                :title='"thumbnailObj,source,destination,battery,bookmark,bitrate,latency".includes(dropCol[index])?"":scope.row[dropCol[index]]'
                v-html='scope.row[dropCol[index]]'>
              </div>
              <!-- bookmark -->
              <div
                :class="[dropCol[index]]"
                v-if='dropCol[index]=="bookmark"'>
                <span
                  class="bookmark_name pointer test"
                  :title='getBookmarkName(scope.row.userBookmarkDevice)'
                  @click.stop='operationBookmarkBox(true, scope.row.userBookmarkDevice, scope.row.peerId)'>{{ getBookmarkName(scope.row.userBookmarkDevice) }}</span>
              </div>
              <!-- battery -->
              <div v-if='dropCol[index]=="battery"'>
                <div class=' f_left clearfix'>
                  <div class="battery1-box f_left">
                    <span
                      class="batterySpan f_left greenColor normalFamily"
                      v-if="isShowSpan1(scope.row.battery,scope.row)">N/A</span>
                    <div
                      class="battery-moudel f_left"
                      v-else
                      :title="scope.row.battery.BAT1VAL + '%'"
                      :class="[Number(scope.row.battery.BAT1VAL) <= 20 ? 'redBorder': '' ]">
                      <div
                        class="battery-dot"
                        :class="[Number(scope.row.battery.BAT1VAL) <= 20 ? 'redBorder': '' ]"></div>
                      <div
                        class="battery1-value"
                        :style="{width:`${scope.row.battery.BAT1VAL}%`}"></div>
                    </div>
                    <i
                      class="iconfont battery-charging top_12 f_left left_5"
                      v-if="scope.row.battery && (scope.row.battery.BAT1 == '2' || scope.row.battery.BAT1 == '0')"></i>
                  </div>
                </div>
              </div>
              <!-- 所有tab添加 -->
              <div v-if='dropCol[index]=="bitrate"'>
                <div class='bitrate_box down_box pr'>
                  <!-- ext和Grid不允许设置Bitrate -->
                  <el-popover
                    v-if="scope.row.bitrateObj && scope.row.bitrateObj.bitrate"
                    trigger="click"
                    placement="top"
                    popper-class="bitrateDelayPopover">
                    <component
                      :is="editBitrateDelayWrap"
                      v-if="bitrateDelayInfo.show"
                      :info="bitrateDelayInfo"/>
                    <!-- <edit-bitrate-delay :info="bitrateDelayInfo"/> -->
                    <span
                      class='down_triangle'
                      slot="reference"
                      :class="{'noPointer': !scope.row.bitrateObj.allowSet}"
                      :title="(scope.row.bitrateObj && scope.row.bitrateObj.bitrate) || ''"
                      @click.stop="openDelayBitratePopover(scope.row, 'bitrate')">
                      <span class="normalFamily">{{ (scope.row.bitrateObj && scope.row.bitrateObj.bitrate) ? `${scope.row.bitrateObj.bitrate}Kbps` : '' }}</span>
                    </span>
                  </el-popover>
                </div>
              </div>
              <div v-if='dropCol[index]=="latency"'>
                <div class='bitrate_box down_box pr'>
                  <el-popover
                    v-if="scope.row.latencyObj && scope.row.latencyObj.delay"
                    trigger="click"
                    placement="top"
                    popper-class="bitrateDelayPopover">
                    <component
                      :is="editBitrateDelayWrap"
                      v-if="bitrateDelayInfo.show"
                      :info="bitrateDelayInfo"/>
                    <!-- <edit-bitrate-delay :info="bitrateDelayInfo"/> -->
                    <span
                      class='down_triangle'
                      slot="reference"
                      :class="{'noPointer': !scope.row.latencyObj.allowSet}"
                      :title="(scope.row.latencyObj && scope.row.latencyObj.delay) || ''"
                      @click.stop="openDelayBitratePopover(scope.row, 'delay')">
                      <span class="normalFamily">{{ `${(scope.row.latencyObj && scope.row.latencyObj.delay) || ''} ${$t('lang.second')}` }}</span>
                    </span>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-table-column>
        </template>

        <el-table-column
          class-name='forbid_drag'
          width="123">
        </el-table-column>
      </el-table>
    </div>

    <div
      class='operation_col'
      :class='{shadow:hasShadow}'
      :style='{left:operationLeft}'>
      <div>
        <p class='f_left'>{{ $t(`lang.operation`) }}</p>
        <el-dropdown
          @command="changeTitle"
          :hide-on-click='false'>
          <span class="el-dropdown-link">
            <i class="el-icon-more pointer el-icon--right"></i>
          </span>
          <el-dropdown-menu
            slot="dropdown"
            class='devicelist_title_list'>
            <el-dropdown-item
              :command='item'
              v-for='(item, index) in allTitle'
              :key='index'>
              <el-checkbox
                :label="$t(`lang.${item}`)"
                v-model="check[item]"></el-checkbox>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div
        class='device_box'
        v-for='item in deviceList'
        :key='item.peerId'>
        <div class="gridLiveEntry">
          <span
            v-show="item.type === 'X' && item.hasSlugPerimission"
            class="iconfont icon-Dashboard"
            :title="$t('lang.gridLogs')"
            @click.stop="openGridLogs(item)"></span>
        </div>
        <div
          class='device_btn'
          @click="prevent($event)">
          <!--引入Take组件-->
          <video-button
            :style="{'margin-left':'10px','float':'right','width':'73px'}"
            :sourceItem='item'
            :hadSelectDevice="isSelectNewR[item.peerId]"
            flag="T"
            parentComponent='sourceList'
            :deviceList="changeRArr[item.peerId]"
            :key="item.peerId"
            @changeHadSelectDevice="changeHadSelectDevice"
            @stopRState="stopRState">
          </video-button>
        </div>
        <div
          class='expend_box'
          v-if='expands[0]==item.peerId'></div>
      </div>
    </div>

    <!-- add bookmark -->
    <component
      :is="addBookmarkWrap"
      v-if="isShow.bookmark"
      :visible='isShow'
      @closeBox='operationBookmarkBox'
      :lastBookmark='updateBookmarkObj.userBookmarkDevice'
      :deviceId='updateBookmarkObj.peerId'
      :deviceObj='{id:updateBookmarkObj.peerId,type:"MySource"}'/>
    <!-- gridLogs -->
    <component
      :is="gridLogsWrap"
      v-if="gridLogsInfo.show"
      :info="gridLogsInfo"/>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import { SHOWDEVICEIMG } from '@/assets/js/filters'
import { mapState } from 'vuex'
import SelectSourceR from '@/components/SelectSourceR'
import videoButton from '@/components/VideoButton'
import Bus from '@/assets/js/vueBus'
import Tool from '@/assets/js/utils.js'
import { isReceiverPreviewDisabled } from '@/utils/receiverPreviewUtils' // WR-323 [Claude Code]
import myWorker from '@/assets/js/worker/sourceList.worker.js'
import { mySourceAnalyze } from '@/assets/js/googleAnalyze/mySource.js'
import TimerManager from '@/utils/TimerManager'
import { cloneDeep } from 'lodash-es'
import { SOURCE_LIST_CONSTANTS } from '@/config.js'

const addBookmarkComponent = () => import('@/components/addBookmark')
const receiverInfoComponent = () => import('@/views/MySource/receiverInfo')
const editBitrateDelayComponent = () => import('@/views/MySource/popover/editBitrateDelay')
const gridLogsComponent = () => import('@/views/MySource/dialog/gridLogs')

export default {
  props: {
    data: Object, // 列表内的实时信息
    imgUrlTime: Object, // 缩略图对象
    initDeviceList: Array, // 列表数据
    page: String // 属于哪个页面
  },
  components: {
    SelectSourceR,
    videoButton
  },
  data () {
    return {
      dropCol: ['thumbnailObj', 'source', 'pid', 'destination', 'liveBitrate', 'bitrate', 'latency', 'format', 'battery', 'bookmark', 'typeVal', 'version', 'location'],
      allTitle: ['pid', 'bitrate', 'latency', 'format', 'battery', 'bookmark', 'typeVal', 'version', 'location'],
      titleArr: [
        {
          name: 'thumbnailObj',
          width: 180
        },
        {
          name: 'source',
          width: 150
        },
        {
          name: 'pid',
          width: 120
        },
        {
          name: 'destination',
          width: 180
        },
        {
          name: 'liveBitrate',
          width: 150
        },
        {
          name: 'bitrate',
          width: 150
        },
        {
          name: 'latency',
          width: 150
        },
        {
          name: 'format',
          width: 150
        },
        {
          name: 'battery',
          width: 130
        },
        {
          name: 'bookmark',
          width: 130
        },
        {
          name: 'typeVal',
          width: 130
        },
        {
          name: 'version',
          width: 130
        },
        {
          name: 'location',
          width: 130
        }
      ],
      lastTitleArr: [],
      removeTitles: [],
      deviceList: [],
      expands: [],
      detailData: {},
      isShow: {
        bookmark: false
      },
      updateBookmarkObj: {
        userBookmarkDevice: null,
        peerId: ''
      },
      checkTitleList: [],
      check: {
        pid: true,
        bitrate: true,
        latency: true,
        format: true,
        battery: true,
        bookmark: true,
        typeVal: true,
        version: true,
        location: true
      },
      isSelectNewR: [], // 是否重新选择了R
      deviceDetailId: '',
      hasStopSelectR: false,
      changeRArr: [],
      receiverObject: {},
      sourceObject: {},
      showStopping: [],
      locationInfo: [],
      deafultImg: 'this.src="' + require('@/assets/img/logo_thumbnail.png') + '"',
      liveRids: [], // home页面发送websocket的liverid数组
      routerPath: '', // 跳转路由的地址
      initCurrentInfoSocket: true,
      currentSocketData: null,
      setBiteDealyFlag: true, // 单次设置防止重复点击
      operationLeft: null,
      hasShadow: false, // 右侧固定列添加阴影
      lang: '',

      // 组件按需加载
      addBookmarkWrap: null,
      receiverInfoWrap: null,
      editBitrateDelayWrap: null,
      gridLogsWrap: null,
      gridLogsInfo: {
        show: false
      },
      bitrateDelayInfo: {
        type: 'bitrate',
        show: false,
        obj: null
      },
      pinkedNum: 0,
      timerManager: new TimerManager() // 定时器管理器
    }
  },
  computed: {
    ...mapState({
      StateObj: state => state,
      pageRequest: state => state.websocket.pageRequest,
      pageRWebsocket: state => state.websocket.pageRWebsocket,
      pinnedDevicesNum: state => state.common.baseUrl.PinnedDevicesNum
    }),
    // quality and error
    listenQualityErrData () {
      return this.$store.state.common.deviceListReceiverDataData
    },
    // format and type
    listenFormatData () {
      return this.$store.state.common.deviceListCurrentRInfoData
    },
    // bitrate and delay
    listenBitDelayData () {
      return this.$store.state.common.deviceListSetInfoData
    },
    openBaiDuMap () {
      return this.$store.state.common?.baseUrl?.openBaiDuMap
    },
    // WR-323: 预览已禁用的 R peerId 集合（随 deviceListCurrentRInfoData 反应式，供列表缩略图门控）[Claude Code]
    disabledRSet () {
      const set = new Set()
      const list = this.$store.state.common.deviceListCurrentRInfoData || []
      list.forEach(v => {
        try { if (isReceiverPreviewDisabled(JSON.parse(v.data))) set.add(v.rid) } catch (e) {}
      })
      return set
    },
    // WR-323: 已收到 currentRInfo(op102) 的 R peerId 集合，供 Live 缩略图门控避免跳转 [Claude Code]
    readyRSet () {
      const set = new Set()
      const list = this.$store.state.common.deviceListCurrentRInfoData || []
      list.forEach(v => { if (v.data) set.add(v.rid) })
      return set
    }
  },
  watch: {
    'data.allSourceData' (val) { // 更新device列表
      if (!this.deviceList.length) return
      this.worker && this.worker.postMessage({
        type: 'hm-sourceListSocket',
        value: {
          list: this.deviceList,
          allSourceData: val,
          liveRids: this.liveRids,
          locationInfo: this.locationInfo,
          isSelectNewR: this.isSelectNewR,
          detailData: this.detailData,
          expands: this.expands
        }
      })
    },
    // 获取列表数据
    initDeviceList: {
      handler (val) {
        this.initDataList(val)
      },
      deep: true,
      immediate: true
    },
    // 更新缩略图
    imgUrlTime: {
      handler () {
        this.updateAllThumbnail()
      },
      deep: true
    },
    // quality and error
    listenQualityErrData (val) {
      val.map((v, i) => {
        if (!this.detailData[v.rid]) this.detailData[v.rid] = {}
        if (Tool.isJSON(v.data)) this.detailData[v.rid].qualityErrInfo = JSON.parse(v.data)
      })
    },
    // format and type
    listenFormatData (val) {
      val.map((v, i) => {
        if (!this.detailData[v.rid]) this.detailData[v.rid] = {}
        if (Tool.isJSON(v.data)) this.detailData[v.rid].formatInfo = JSON.parse(v.data)
      })
    },
    // bitrate and delay
    listenBitDelayData (val) {
      val.map((v, i) => {
        if (!this.detailData[v.rid]) this.detailData[v.rid] = {}
        if (Tool.isJSON(v.data)) this.detailData[v.rid].bitDelayInfo = JSON.parse(v.data)
      })
    }
  },
  async created () {
    this.lang = window.localStorage.getItem('lang')
    this.initDataList(this.initDeviceList)
    await this.getBehavior()
    await this.getOperationPosition()
    window.addEventListener('resize', this.handleResize)
    this.isBoxShadow()
    Bus.$on('openRVideoDetail', data => {
      if (data) { // 打开R详情框
        this.stopupdateParams()
        return
      }
      this.createMsgWebsocket()
      this.updateParams()
    })

    // 启动 web worker
    this.worker = new myWorker()
    if (this.worker) {
      this.worker.onmessage = (event) => {
        this.handleWorkerMessage(event.data)
      }

      this.worker.onerror = (error) => {
        console.log('Worker error:', error.message, error.filename, error.lineno)
      }
    }
  },
  mounted () {
    this.columnDrop()
    this.routerPath = this.$route.path
    this.handleResize()
  },
  methods: {
    // WR-323: 该行 Live 源对应 R 是否禁用了实时预览（列表缩略图仅显图标 + hover 文案）[Claude Code]
    rowPreviewDisabled (row) {
      if (!row) return false
      const type = row.type
      const isGridHub = type === 'X' && row.peerId && row.peerId.toLowerCase().endsWith('0000000000000003')
      if (Number(row.status) !== 2 || (type === 'X' && !isGridHub)) return false
      const rPeerId = (row.livePeerId || '').split(';')[0]
      return this.disabledRSet.has(rPeerId)
    },
    // WR-323: 该行 Live 源对应 R 的 currentRInfo 是否已到达（未到达前不显直播缩略图，避免跳转）[Claude Code]
    rowRInfoReady (row) {
      if (!row) return true
      const type = row.type
      const isGridHub = type === 'X' && row.peerId && row.peerId.toLowerCase().endsWith('0000000000000003')
      if (Number(row.status) !== 2 || (type === 'X' && !isGridHub)) return true
      const rPeerId = (row.livePeerId || '').split(';')[0]
      return this.readyRSet.has(rPeerId)
    },
    copyDeviceInfo (e, text) {
      Tool.copyText(e, text)
    },
    handleWorkerMessage (message) {
      const { type, value } = message
      if (type == 'hm-sourceListSocket') {
        const { deviceList, liveRids, dataObj } = value
        if (this.deviceList) {
          this.deviceList.forEach((v, index) => {
            let item = deviceList.find(m => m.peerId == v.peerId)
            if (item && item.changeStatus) item.thumbnailObj = SHOWDEVICEIMG(v)
            if (item) item.liveBitrate = item.liveBitrate ? `${item.liveBitrate} kbps` : ''
            if (item) this.$set(this.deviceList, index, item)
          })
        }
        this.liveRids = cloneDeep(liveRids)
        if (dataObj) Bus.$emit('showReceiverInfo', dataObj)
      }
    },
    // 打开Bitrate和Latency设置窗口
    async openDelayBitratePopover (row, tag) {
      const editBitrateDelayWrap = await editBitrateDelayComponent()
      this.editBitrateDelayWrap = editBitrateDelayWrap.default
      this.bitrateDelayInfo.obj = row
      this.bitrateDelayInfo.type = tag
      this.bitrateDelayInfo.show = true
    },
    // 正常的定时器更新所有缩略图
    updateAllThumbnail () {
      if (!this.deviceList.length) return
      this.deviceList.map((v, i) => {
        let item = { ...v }
        const { type, status } = item
        if (status == 2 && type != 'X') {
          if (this.imgUrlTime.current[item.livePeerId] == this.imgUrlTime.last[item.livePeerId]) return
        } else {
          if ((type == 'Ext' || type == 'YouTube') && status == 1) {
            if (!this.imgUrlTime.last[item.peerId] && !this.imgUrlTime.current[item.peerId]) {
              item.thumbnailObj = SHOWDEVICEIMG(v, true)
              this.$set(this.deviceList, i, item)
              return
            }
          } else {
            if (!this.imgUrlTime.last[item.peerId] && !this.imgUrlTime.current[item.peerId]) {
              item.thumbnailObj = SHOWDEVICEIMG(v, true)
              this.$set(this.deviceList, i, item)
              return
            }
            if (this.imgUrlTime.current[item.peerId] == this.imgUrlTime.last[item.peerId]) return
          }
        }
        item.thumbnailObj = SHOWDEVICEIMG(v)
        this.$set(this.deviceList, i, item)
      })
    },
    isShowSpan1 (i, a) {
      if (i == undefined || !i || (a && a.type != 'T')) return true
      if (i && i.BAT1) {
        const bat1 = i.BAT1
        if (bat1 == -1 || bat1 == null || bat1 == '') {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    // 窗口大小调整
    handleResize () {
      if (document.documentElement.clientWidth >= 1920) {
        const boxWidth = this.$refs.deviceListBox && this.$refs.deviceListBox.offsetWidth || Number(document.documentElement.clientWidth - 64)
        const totalWidth = boxWidth - (SOURCE_LIST_CONSTANTS.DROPDOWN_COL_WIDTH + SOURCE_LIST_CONSTANTS.OPERATION_COL_WIDTH)
        let newWidth = Math.ceil(totalWidth / this.titleArr.length)// 每列的宽度
        newWidth = newWidth < SOURCE_LIST_CONSTANTS.MIN_COL_WIDTH ? SOURCE_LIST_CONSTANTS.MIN_COL_WIDTH : newWidth
        const titleArr = cloneDeep(this.titleArr)
        titleArr.forEach((v) => {
          if (v && typeof v === 'object') {
            v.width = newWidth
            v.width = v.name == 'thumbnailObj' && newWidth < SOURCE_LIST_CONSTANTS.THUMBNAIL_MIN_WIDTH ? SOURCE_LIST_CONSTANTS.THUMBNAIL_MIN_WIDTH : newWidth
          }
        })
        this.titleArr = cloneDeep(titleArr)
        this.lastTitleArr = cloneDeep(this.titleArr)
        this.setBehavior()
      }
      this.getOperationPosition()
    },
    async openGridLogs (row) {
      this.$TVU.usageService = this.StateObj.common.baseUrl.usageService
      if (!this.$TVU.usageService) return
      const gridLogsWrap = await gridLogsComponent()
      this.gridLogsWrap = gridLogsWrap.default
      this.gridLogsInfo = row
      this.gridLogsInfo.show = true
    },
    // 获取固定操作栏位置
    async getOperationPosition () {
      await new Promise(resolve => {
        this.timerManager.setTimeout('operationPosition', () => {
          const tableEl = this.$refs.topicTable && this.$refs.topicTable.$el
          const tableHeaderEl = tableEl && tableEl.querySelector('.el-table__header-wrapper table')
          const tableWidth = tableHeaderEl ? tableHeaderEl.offsetWidth : 0

          if (this.$refs.deviceListBox && tableWidth > 0) {
            const screenWidth = this.$refs.deviceListBox.offsetWidth
            this.operationLeft = screenWidth - tableWidth > SOURCE_LIST_CONSTANTS.OPERATION_COL_WIDTH
              ? `${tableWidth}px`
              : `${screenWidth - SOURCE_LIST_CONSTANTS.OPERATION_COL_WIDTH}px`
          }
          resolve()
        }, 100)
      })
    },
    createMsgWebsocket () {
      this.stopupdateParams()
      this.sendMsgWebsocket('CurrentRInfo', '2152857600', '102', 1000) // 获取type and format信息
      this.sendMsgWebsocket('SetInfo', '2152866048', '101', 1000) // 获取bitrate and delay信息
    },
    sendMsgWebsocket (type, categoryId, operationType, time) {
      let typeVal = ''
      if (type != 'VolumeChart') typeVal = `${type[0].toLowerCase()}${type.slice(1, type.length)}`
      this.pageRWebsocket.send({
        message: {
          categoryId: categoryId,
          operationType: operationType,
          rid: this.liveRids.join(',')
        },
        time: time || 5000,
        key: typeVal || type,
        success: res => {
          this.updateDevice(res)
        }
      })
    },
    updateParams () {
      this.updateSocketParams('currentRInfo', '2152857600', '102')
      this.updateSocketParams('setInfo', '2152866048', '101')
    },
    stopupdateParams () { // 停止获取数据
      if (this.$createWebsocket.pageRWebsocket) {
        this.$createWebsocket.pageRWebsocket('stop', ['currentRInfo', 'setInfo']) // 停止websocket
      }
    },
    // 更新websocket参数
    updateSocketParams (type, categoryId, operationType) {
      const message = {
        categoryId,
        operationType,
        rid: this.liveRids.join(',')
      }
      if (this.pageRWebsocket.sendMsgs && this.pageRWebsocket.sendMsgs[type]) {
        this.pageRWebsocket.sendMsgs[type].message = message
      }
    },
    // 更新参数
    updateSourceParam () {
      this.timerManager.setInterval('updateSourceParam', () => {
        const tPeerIdObjs = this.deviceList.filter(v => {
          return v.type.toLowerCase() == 't' && v.status != 0 && v.status != 2
        })
        let tPeerIds = []
        tPeerIdObjs.map(v => {
          tPeerIds.push(v.peerId)
        })
        if (!tPeerIds.length) {
          if (this.$createWebsocket.pageRequest) {
            this.$createWebsocket.pageRequest('stop', 'detailInfo') // 停止websocket taskInfo_R_W这个可以自定义 发送什么返回什么
            return
          }
        } else {
          if (!this.pageRequest.sendMsgs || this.pageRequest.sendMsgs && !this.pageRequest.sendMsgs.detailInfo) {
            this.timerManager.clearInterval('updateSourceParam')
            this.getOnlineData()
          }
        }
        if (this.pageRequest.sendMsgs && this.pageRequest.sendMsgs.detailInfo) {
          const msgData = this.pageRequest.sendMsgs.detailInfo.message && this.pageRequest.sendMsgs.detailInfo.message.data
          if (msgData) {
            const currentPeerId = msgData.peerIds
            for (let i = 0; i < tPeerIds.length; i++) {
              if (tPeerIds[i] == currentPeerId) {
                msgData.peerIds = tPeerIds[i + 1] ? tPeerIds[i + 1] : tPeerIds[0]
                break
              }
            }
          }
        }
      }, 2000)
    },
    // 获取在线的数据
    getOnlineData () {
      const tPeerIdObjs = this.deviceList.filter(v => {
        return v.type.toLowerCase() == 't' && v.status != 0 && v.status != 2
      })
      let tPeerIds = []
      tPeerIdObjs.map(v => {
        tPeerIds.push(v.peerId)
      })
      if (this.$createWebsocket.pageRequest) {
        this.$createWebsocket.pageRequest('stop', 'detailInfo') // 停止websocket taskInfo_R_W这个可以自定义 发送什么返回什么
      }
      this.pageRequest && this.pageRequest.send({
        message: {
          type: 'detailInfo',
          module: 'detailInfo',
          data: { peerIds: tPeerIds[0] }
        },
        time: 1000,
        key: 'detailInfo',
        success: data => {
          // 用于低电量通知
          this.$store.state.deviceBattery = data
          if (Tool.isJSON(data.result)) {
            try {
              const deviceData = JSON.parse(data.result)[0]
              if (!deviceData) return
              const targetDevice = this.deviceList.find(v => v.peerId.toLowerCase() === deviceData.peerId.toLowerCase())

              if (targetDevice) {
                // 处理电池数据
                targetDevice.battery = JSON.parse(deviceData.CurrentTPackBatteryRaw)

                // 处理媒体格式数据
                const mediaFormat = (deviceData.media && deviceData.media.format).split(',')
                targetDevice.format = mediaFormat ? this.$options.filters.TRANSFORMFORMAT(mediaFormat[2]) : 'N/A'

                // 特殊类型处理
                if (targetDevice.type.toLowerCase() === 't' && targetDevice.status === 3) {
                  targetDevice.format = 'N/A'
                }
              }
            } catch (error) {
              console.log('设备数据处理错误:', error)
            }
          }
        }
      })
      this.updateSourceParam(tPeerIds)
    },
    prevent (e) {
      e.stopPropagation()
    },
    // 更改title显示
    changeTitle (key) {
      this.timerManager.setTimeout('changeTitle', () => {
        // 重新构建列数组，避免先清空导致界面闪烁
        this.titleArr = cloneDeep(this.lastTitleArr)
        this.dropCol = []
        const boxWidth = this.$refs.deviceListBox.offsetWidth
        const totalWidth = boxWidth - (SOURCE_LIST_CONSTANTS.DROPDOWN_COL_WIDTH + SOURCE_LIST_CONSTANTS.OPERATION_COL_WIDTH)
        let addIndex
        this.check[key] && this.removeTitles.forEach((v, i) => { // 添加
          if (v.name == key) {
            addIndex = i
          }
        })
        let index
        // 计算新列宽，防止除以0
        const columnCount = this.check[key] ? this.titleArr.length + 1 : Math.max(this.titleArr.length - 1, 1)
        let newWidth = Math.ceil(totalWidth / columnCount) // 每列的宽度
        newWidth = newWidth < SOURCE_LIST_CONSTANTS.MIN_COL_WIDTH ? SOURCE_LIST_CONSTANTS.MIN_COL_WIDTH : newWidth
        this.titleArr.forEach((v, i) => {
          if (v && typeof v === 'object') {
            v.width = newWidth
            v.width = v.name == 'thumbnailObj' && newWidth < SOURCE_LIST_CONSTANTS.THUMBNAIL_MIN_WIDTH ? SOURCE_LIST_CONSTANTS.THUMBNAIL_MIN_WIDTH : newWidth
            if (v.name == key) { // 找出当前列的下标，移除时可使用
              index = i
              v.index = i
              this.check[key] && this.dropCol.push(v.name)
            } else {
              this.dropCol.push(v.name)
            }
          }
        })
        // 移除列时，确保 index 有效且不会 push undefined
        if (!this.check[key] && index !== undefined) {
          const removedItem = this.titleArr.splice(index, 1)[0]
          if (removedItem) {
            this.removeTitles.push(removedItem)
          }
        }
        // 添加列时，确保元素有效
        if (this.check[key] && this.removeTitles[addIndex]) {
          this.removeTitles[addIndex].width = newWidth
          this.dropCol.splice(this.removeTitles[addIndex].index, 0, this.removeTitles[addIndex].name) // 添加时插入元素
          this.titleArr.splice(this.removeTitles[addIndex].index, 0, this.removeTitles[addIndex]) // 添加时插入元素
          this.removeTitles.splice(addIndex, 1)
        }
        // 清理数组中可能存在的 undefined/null 元素
        this.titleArr = this.titleArr.filter(item => item && typeof item === 'object')
        this.lastTitleArr = cloneDeep(this.titleArr)
        // 清空上次选中的R
        this.changeRArr = []
        this.isSelectNewR = []
        this.setBehavior()
        this.getOperationPosition()
      })
      this.goolgeAlativite('mysource', key)
    },
    goolgeAlativite (x, y) { // 谷歌统计筛选框
      switch (y) {
        case 'bitrate':
          mySourceAnalyze('mySourceTableBitrate', this.$route.path) // 谷歌统计
          break
        case 'latency':
          mySourceAnalyze('mySourceTableLatency', this.$route.path) // 谷歌统计
          break
        case 'format':
          mySourceAnalyze('mySourceTableFormat', this.$route.path) // 谷歌统计
          break
        case 'battery':
          mySourceAnalyze('mySourceTableBattery', this.$route.path) // 谷歌统计
          break
        case 'bookmark':
          mySourceAnalyze('mySourceTableBookmark', this.$route.path) // 谷歌统计
          break
        case 'typeVal':
          mySourceAnalyze('mySourceTableTypeVal', this.$route.path) // 谷歌统计
          break
        case 'version':
          mySourceAnalyze('mySourceTableVersion', this.$route.path) // 谷歌统计
          break
        case 'location':
          mySourceAnalyze('mySourceTableLocation', this.$route.path) // 谷歌统计
          break
      }
    },
    // 更改device列表
    initDataList (val) {
      // 先创建骨架屏结构
      if (!val || val.length === 0) return
      let list = cloneDeep(val)
      const devicePeerIdArr = []
      for (let item of list) {
        item.thumbnailObj = SHOWDEVICEIMG(item)
        item.source = item.name
        item.destination = item.livePeerName
        item.liveBitrate = ''
        item.bitrateObj = {
          bitrate: '',
          allowSet: false
        }
        item.latencyObj = {
          delay: '',
          allowSet: false
        }
        item.bitrate = ''
        item.latency = ''
        item.format = ''
        item.battery = null
        // item.battery = showBattery(item.batteryInfo, item.platform)
        item.btnStatus = item.status == 2 ? 'stop' : 'goLive' // 按钮状态
        item.location = ''
        item.typeVal = this.$options.filters.SETTINGTYPE(item)
        item.changeStatus = false
        item.pinked = false
        devicePeerIdArr.push(item.peerId)
      }
      this.deviceList = list
      this.getLastLiveDevice(devicePeerIdArr)
      this.getOnlineData()
      // 更新列表后立即获取一次缩略图
      this.updateAllThumbnail()
      this.getLocationData(0)
      this.getPinkedSource()
    },
    // 异步获取置顶的数据，只有第一页才需要
    getPinkedSource () {
      this.axios.get('/ccp/tvucc-user/userDevice/searchUserPinnedDevices').then(res => {
        if (res.data.errorCode == '0x0') {
          const pinkedList = res.data.result
          this.pinkedNum = pinkedList ? pinkedList.length : 0
          if (this.pinkedNum > 0) {
            this.deviceList.forEach(item => {
              item.pinked = pinkedList.some(pinkedItem => pinkedItem.peerId === item.peerId)
            })
          } else {
            this.deviceList.forEach(item => {
              item.pinked = false
            })
          }
        }
      }).catch(() => {})
    },
    // 置顶功能
    setSourceToTop (row) {
      if (!row.peerId) return
      if (Number(this.pinkedNum) >= Number(this.pinnedDevicesNum) && !row.pinked) {
        this.$message.info(this.$t('lang.topMax', { maxNum: this.pinnedDevicesNum }))
        return
      }
      this.axios.get(`/ccp/tvucc-user/userDevice/setUserPinnedDevices?peerId=${row.peerId}&pinnedFlag=${!row.pinked}`).then(res => {
        if (res.data.errorCode == '0x0') {
          if (!row.pinked) this.$message.success(`${row.name} ${this.$t('lang.topSuccess')}`)
          if (row.pinked) this.$message.success(`${row.name} ${this.$t('lang.untopSuccess')}`)
          setTimeout(() => {
            Bus.$emit('updateSourceListInfo')
          }, 300)
        }
      }).catch(() => {})
    },
    // 异步获取最后一次Live的设备信息
    getLastLiveDevice (peerArr) {
      return this.axios.post('/ccp/tvucc-device/device/getDeviceLastLivePidMsg', peerArr, {
        contentType: 'application/json;charset=UTF-8',
        isCancelToken: true
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result.length) {
            const resultArr = res.data.result
            resultArr.forEach(m => {
              const index = this.deviceList.findIndex(v => v.peerId == m.peerId)
              if (index >= 0 && m.livePid) {
                this.deviceList[index].lastLiveName = m.peerName
              }
            })
          }
        }
      }).catch(() => {})
    },
    getBookmarkName (userBookmarkDevice) {
      let selectBookmark = []
      if (userBookmarkDevice) {
        let bookmarkList = []
        for (let key in userBookmarkDevice) {
          bookmarkList.push(userBookmarkDevice[key])
        }
        bookmarkList.map(v => {
          let arr = [`${v[0].bookmarkName}`]
          if (v[0].parent.length) {
            this.getParent(v[0].parent[0], arr)
          }
          selectBookmark.push(arr.join(','))
        })
      }
      return selectBookmark.join(',') || '- - -'
    },
    // 获取父级id和name
    getParent (parent, arr) {
      arr.unshift(`${parent.bookmarkName}`)
      if (parent.parent.length) {
        this.getParent(parent.parent[0], arr)
      }
    },
    // 打开bookmark box
    async operationBookmarkBox (flag, userBookmarkDevice, peerId) {
      if (flag) {
        this.updateBookmarkObj.userBookmarkDevice = userBookmarkDevice
        this.updateBookmarkObj.peerId = peerId
        // 动态加载组件
        const ShowAddBookmarkWrap = await addBookmarkComponent()
        this.addBookmarkWrap = ShowAddBookmarkWrap.default
      }
      this.isShow.bookmark = flag
      mySourceAnalyze('mySourceTableShowBookmark', this.$route.path)
    },
    // 列拖拽
    columnDrop () {
      const wrapperTr = document.querySelector('.el-table__header-wrapper tr')
      if (!wrapperTr) return
      this.sortable = Sortable.create(wrapperTr, {
        animation: 150,
        delay: 0,
        filter: 'th.forbid_drag', // 过滤器，不需要进行拖动的元素
        onEnd: evt => {
          if (evt.oldIndex <= 3 || evt.newIndex <= 3) { // 禁止移入固定列
            if (!document.querySelector('.el-table__header-wrapper .has-gutter>tr')) return
            const moveEle = document.querySelectorAll('.el-table__header-wrapper .has-gutter th')[evt.newIndex]
            document.querySelector('.el-table__header-wrapper .has-gutter>tr').removeChild(moveEle)
            document.querySelector('.el-table__header-wrapper .has-gutter>tr').insertBefore(moveEle, document.querySelectorAll('.el-table__header-wrapper .has-gutter th')[evt.oldIndex])
            return
          }
          const oldItem = this.dropCol[evt.oldIndex - 1]
          this.dropCol.splice(evt.oldIndex - 1, 1)
          this.dropCol.splice(evt.newIndex - 1, 0, oldItem)
          // 改变title数组
          const data = this.lastTitleArr.splice(evt.oldIndex - 1, 1)
          this.lastTitleArr.splice(evt.newIndex - 1, 0, data[0])
          mySourceAnalyze('mySourceTableDragColumn', this.$route.path)
        }
      })
    },
    // 安全销毁 sortable 实例
    destroySortable () {
      if (this.sortable) {
        try {
          this.sortable.destroy()
        } catch (error) {
          console.log('Sortable destroy error:', error)
        } finally {
          this.sortable = null
        }
      }
    },
    // device status
    getStatusClass (item) {
      switch (Number(item.status)) {
        case 1:
        case 3:
          return 'green'
        case 2:
          return 'red'
        default:
          return ''
      }
    },
    // 关闭弹窗
    closeVideoBox () {
      Bus.$emit('openListWebsocket', 'sourceList')
      // 关闭弹窗后重新获取bitrate delay和format
      this.createMsgWebsocket()
      this.updateParams()
      this.initCurrentInfoSocket = false
    },
    // 展开详情框
    async expandDetail (row, column, event) {
      mySourceAnalyze('mySourceTableShowVideo', this.$route.path)
      const receiverInfoWrap = await receiverInfoComponent()
      this.receiverInfoWrap = receiverInfoWrap.default
      this.$nextTick(() => {
        let quality = document.querySelector('#quality')
        if (quality) quality.id = 'quality-last'
        if (this.expands[0] == row.peerId) {
          this.expands = []
          const dataObj = {
            rid: '',
            sourceItem: {},
            isDown: false
          }
          Bus.$emit('showReceiverInfo', dataObj)
          return
        }
        this.expands = []
        if (row.status == 0) return
        this.expands.push(row.peerId)
      })
    },
    // 获取delay
    // getDelay (value, setFlag) {
    //   if (!setFlag) {
    //     const val = this.$t('lang.Dynamic')
    //     return val
    //   }
    //   return `${value} s`
    // },
    // 获取是否重新选择了R
    changeHadSelectDevice (val, peerId) {
      this.isSelectNewR[peerId] = val
      mySourceAnalyze('mySourceTableSelectR', this.$route.path)
    },
    getSelectInfo (data) { // 获取SelectSourceR.vue组件的参数
      this.changeRArr[data.rid] = data.deviceList // 监听SelectSourceR.vue组件传递过来的参数
      const currentSelectRid = data.deviceList.split(',')[1]
      const gridLivePeerId = this.data.allSourceData && this.data.allSourceData[data.rid] && this.data.allSourceData[data.rid].gridLivePeerId
      if (gridLivePeerId != null) {
        if (gridLivePeerId.includes(currentSelectRid)) {
          this.deviceDetailId = currentSelectRid
        }
      }
      this.hasStopSelectR = false
    },
    stopRState () {
      this.hasStopSelectR = true
    },
    // 获取地理位置信息
    getLocationData (time) {
      this.lang = window.localStorage.getItem('lang')
      let mapType = ''
      if (this.lang == 'zh' && this.openBaiDuMap) {
        mapType = 'baidu'
      }
      const tPeerIdObjs = this.deviceList.filter(v => {
        return v.type.toLowerCase() == 't' || v.type.toLowerCase() == 'x'
      })
      let tPeerIds = []
      tPeerIdObjs.map(v => {
        let peerId = ''
        if (v.type.toLowerCase() == 'x') {
          peerId = v.peerId.slice(0, 16)
        } else {
          peerId = v.peerId
        }
        tPeerIds.push(peerId)
      })
      if (this.$createWebsocket.pageRequest) {
        this.$createWebsocket.pageRequest('stop', 'getLocationByIps_hm') // 停止websocket taskInfo_R_W这个可以自定义 发送什么返回什么
      }
      this.pageRequest && this.pageRequest.send({
        message: {
          type: 'getLocationByIps',
          module: 'getLocationByIps_hm',
          data: { peerIds: tPeerIds.join(','), peerIps: '', mapType: mapType }
        },
        time: time,
        key: 'getLocationByIps_hm',
        success: res => {
          const data = res.result
          if (data.errorCode == '0x0') {
            if (data.result) {
              try {
                if (JSON.parse(data.result) && JSON.parse(data.result).data && JSON.parse(data.result).data.length > 0) {
                  const locationArr = JSON.parse(data.result).data
                  this.locationInfo = []
                  locationArr && locationArr.map(v => {
                    if (v.address && typeof v.address != 'string') {
                      let address = ''
                      v.address.map((item, idx) => {
                        if (idx != v.address.length - 1) {
                          address += (item.long_name + ' , ')
                        } else {
                          address += item.long_name
                        }
                      })
                      v.address = address
                    }
                    this.locationInfo[v.peerId.toLowerCase()] = v
                  })
                }
              } catch (error) {
              }
            }
          }
          // let newParam = []
          this.$createWebsocket.pageRequest('stop', 'getLocationByIps_hm')
          this.getLocationData(60000)
        }
      })
    },
    // 获取table记录
    async getBehavior () {
      const params = {
        pn: location.hash.split('?')[0].slice(2),
        remark: this.StateObj.common.baseUserInfo.id,
        serverName: 'ccp'
      }
      await this.axios.get('/ccp/tvucc-user/userBehavior/get', { params })
        .then(res => {
          if (res.data.errorCode == '0x0') {
            if (!res.data.result || !res.data.result[this.StateObj.common.baseUserInfo.id]) {
              this.lastTitleArr = cloneDeep(this.titleArr)
              return
            }
            const result = JSON.parse(res.data.result[this.StateObj.common.baseUserInfo.id])
            const selectResult = result.select
            for (const key in this.check) { // 多选全部置为false
              this.check[key] = false
            }
            let titleArr = []
            this.dropCol = []
            for (const key in selectResult) {
              if (Object.prototype.hasOwnProperty.call(this.check, key)) this.check[key] = true // 多选选中的为true
              titleArr.push({ name: selectResult[key].name, width: selectResult[key].width })
              this.dropCol.push(selectResult[key].name)
            }
            this.titleArr = cloneDeep(titleArr)
            this.lastTitleArr = cloneDeep(this.titleArr)
            // 没有被选中的列
            this.removeTitles = result.unSelect
          }
        }).catch(error => {
          console.log('获取用户行为配置失败:', error)
        })
    },
    // 保存table记录
    setBehavior (newWidth, oldWidth, column) {
      let isRefresh = false
      let titleArr = cloneDeep(this.titleArr)

      // 处理列宽调整；column 可能为 null（Element UI @header-dragend 边界情况，Sentry CC-3-0-UI-A4）
      // 注意：newWidth 为 0 时视为"无调整"跳过，与之前行为一致
      if (newWidth && column) {
        mySourceAnalyze('mySourceTableColumnStretch', this.$route.path)
        titleArr = cloneDeep(this.lastTitleArr)
        if (titleArr.length && column) {
          if (oldWidth - newWidth > 0) { // 当前列宽减少了
            // 数组越界检查：确保至少有2列才能进行宽度调整
            if (titleArr.length >= 2) {
              // titleArr 元素可能为空（lastTitleArr 含空洞/脏数据），访问 .name/.width 前先判空（Sentry CC-3-0-UI-B3）
              const lastCol = titleArr[titleArr.length - 1]
              const secondLastCol = titleArr[titleArr.length - 2]
              if (!column.className || !lastCol || !column.className.split(' ').includes(lastCol.name)) { // 当前列宽(非最后一列)减少的给最后一列加上去
                if (lastCol) lastCol.width = Number(lastCol.width) + oldWidth - newWidth
              } else { // 最后一列列宽减少的给倒数第二列加上去
                if (secondLastCol) secondLastCol.width = Number(secondLastCol.width) + oldWidth - newWidth
              }
            }
          }
          // 更改调整后的列宽记录
          const classNames = column.className ? column.className.split(' ') : []
          for (let i = 0; i < titleArr.length; i++) {
            if (titleArr[i] && classNames.includes(titleArr[i].name)) { // 跳过空元素，避免读取 undefined.name（Sentry CC-3-0-UI-B3）
              isRefresh = newWidth < SOURCE_LIST_CONSTANTS.MIN_COL_WIDTH
              titleArr[i].width = newWidth < SOURCE_LIST_CONSTANTS.MIN_COL_WIDTH ? SOURCE_LIST_CONSTANTS.MIN_COL_WIDTH : newWidth
            }
          }
          if (classNames[0] === 'thumbnailObj' && titleArr[0]) {
            isRefresh = newWidth < SOURCE_LIST_CONSTANTS.THUMBNAIL_MIN_WIDTH
            titleArr[0].width = newWidth < SOURCE_LIST_CONSTANTS.THUMBNAIL_MIN_WIDTH ? SOURCE_LIST_CONSTANTS.THUMBNAIL_MIN_WIDTH : newWidth
          }
        }
      }
      this.lastTitleArr = cloneDeep(titleArr)
      let selectObj = {}
      for (const value of titleArr) {
        if (value) selectObj[value.name] = value // 跳过空元素，避免 undefined.name（Sentry CC-3-0-UI-B3）
      }
      const record = {
        select: selectObj,
        unSelect: this.removeTitles
      }
      const params = {
        pn: location.hash.split('?')[0].slice(2),
        remark: this.StateObj.common.baseUserInfo.id,
        content: JSON.stringify(record)
      }
      // 异步保存配置到后端（不阻塞 UI 更新）
      this.axios.post('/ccp/tvucc-user/userBehavior/set', params)
        .then(res => {
          if (res.data.errorCode === '0x0') console.log('列宽配置已保存')
        }).catch(error => {
          console.log('保存用户行为配置失败:', error)
        })

      // 改变view层
      if (isRefresh) {
        this.$nextTick(() => {
          this.titleArr = cloneDeep(titleArr)
        })
      }

      // 只在需要时重建 Sortable（避免频繁销毁重建）
      this.$nextTick(() => {
        this.destroySortable()
        this.isBoxShadow()
        this.columnDrop()
      })
    },
    // 判断是否有滚动条，如果有右侧固定列添加阴影效果
    isBoxShadow () {
      this.timerManager.setTimeout('checkBoxShadow', () => {
        const bodyWrapper = document.querySelector('.table_box .el-table__body-wrapper')
        this.hasShadow = bodyWrapper ? !bodyWrapper.classList.contains('is-scrolling-none') : false
      }, 100)
    },
    updateDevice (b) {
      if (b.operationType == 101) {
        this.deviceList.map((v) => {
          if (v.livePeerId == b.rid) {
            // if (v.status != '2') v.liveBitrate = JSON.parse(b.data).CurrentSetting.Bitrate + ' Kbps'
            v.BitrateNum = (JSON.parse(b.data).CurrentSetting && JSON.parse(b.data).CurrentSetting.Bitrate)
            v.livelatency = (JSON.parse(b.data).CurrentSetting && JSON.parse(b.data).CurrentSetting.Delay)
            v.StrVideoMode = (JSON.parse(b.data).CurrentSetting && JSON.parse(b.data).CurrentSetting.StrVideoMode)
            v.CurrentTCanSetVideoMode = JSON.parse(b.data).CurrentTCanSetVideoMode
            v.CurrentTCanSetDelay = JSON.parse(b.data).CurrentTCanSetDelay
            v.CurrentTCanSetDelayConfigurable = JSON.parse(b.data).CurrentTCanSetDelayConfigurable
            v.CurrentTCanSetBitrate = JSON.parse(b.data).CurrentTCanSetBitrate
          }
        })
      }
      if (b.operationType == 102) {
        this.deviceList.map((v) => {
          if (v.livePeerId == b.rid) {
            if (v.format != JSON.parse(b.data).CurrentTFormat.ReadableName) {
              v.ReadableName = JSON.parse(b.data).CurrentTFormat.ReadableName
            }
            v.CurrentTPackBatteryRaw = JSON.parse(b.data).CurrentTPackBatteryRaw
          }
        })
      }
    },
    // 统一清理 WebSocket 连接
    cleanupWebSockets () {
      if (this.$createWebsocket.pageRWebsocket) {
        this.$createWebsocket.pageRWebsocket('stop', ['currentRInfo', 'setInfo'])
      }
      if (this.$createWebsocket.pageRequest) {
        this.$createWebsocket.pageRequest('stop', ['detailInfo', 'getLocationByIps_hm'])
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    Bus.$off('openRVideoDetail')
    this.timerManager.clearAll()
    this.cleanupWebSockets()
    next()
  },
  beforeDestroy () {
    // 1. 清理所有定时器
    this.timerManager.clearAll()

    // 2. 清理 Event Bus
    Bus.$off('openRVideoDetail')

    // 3. 清理 Sortable
    this.destroySortable()

    // 4. 清理 DOM 事件
    window.removeEventListener('resize', this.handleResize)

    // 5. 清理 WebSocket
    this.cleanupWebSockets()

    // 6. 清理 Web Worker
    if (this.worker) {
      this.worker.terminate()
      this.worker = null
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .el-table .el-table__header-wrapper .has-gutter {
  .cell {
    max-height: 46px;
  }

  tr,
  th {
    background: #252525;
    border-bottom: 2px solid #217536;
  }
}

.device_list {
  .operation_col.shadow {
    box-shadow: -7px 0 18px #222;
  }

  .operation_col {
    width: 123px;
    min-width: 123px; /* 防止宽度变化 */
    box-sizing: border-box;
    position: absolute;
    right: 0; /* 改为固定右侧定位 */
    top: 0;
    background: #252525;
    padding-right: 15px;
    z-index: 10;

    .el-icon-more {
      transform: rotate(-90deg);
      color: #666;
    }

    ::v-deep .el-dropdown {
      float: right;
    }

    > div:first-child {
      height: 25px;
      line-height: 20px;
      border-bottom: 2px solid #217536;
      color: rgb(144, 147, 153);
      font-weight: 700;
      padding-left: 15px;
    }
    .gridLiveEntry {
      display: inline-block;
      height: 20px;
      width: 20px;
    }
    .device_btn {
      height: 87px;
      line-height: 87px;
      border-bottom: 1px solid #333;
      // padding-left: 15px;
      display: inline-block;
    }
  }
  ::v-deep .el-table__header-wrapper .has-gutter .cell {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  ::v-deep .not_allow {
    cursor: not-allowed;
  }

  // margin-right: 20px;
  ::v-deep .cell {
    .bookmark,
    .battery,
    .source,
    .pid,
    .typeVal,
    .format,
    .version,
    .location {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .source,
    .pid {
      cursor: pointer;
      &:hover {
        color: #33ab4f;
      }
    }
  }

  ::v-deep .el-table--border th,
  ::v-deep .el-table th {
    border-color: #333;
  }

  ::v-deep .el-table--border thead th {
    border-width: 0;
  }

  ::v-deep tr > th:first-child {
    border-right: none;
  }

  ::v-deep tr > td:first-child {
    .el-table__expand-icon {
      display: none;
    }
  }

  ::v-deep .el-table--border thead:hover th {
    border-right-width: 2px;
  }

  ::v-deep .el-table--border td,
  ::v-deep .el-table .el-table-row td,
  ::v-deep .el-table tr td {
    border-left: none;
    border-right: none;
    background: #252525;
  }

  ::v-deep .el-table--group,
  ::v-deep .el-table--border {
    border: none;
  }

  ::v-deep .el-table--group::after,
  ::v-deep .el-table--border::after,
  ::v-deep .el-table::before {
    background: transparent;
  }

  ::v-deep .el-table .el-table__row td .cell,
  ::v-deep .el-table .el-table__row th .cell {
    height: 86px;
    min-height: 86px; /* 添加最小高度 */
    line-height: 86px;
    overflow: visible;
    box-sizing: border-box;

    > span {
      width: 100%;
      display: inline-block;
      overflow: hidden;
    }
  }

  ::v-deep .bitrate_box {
    span {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  ::v-deep tr > td:first-child .el-icon-arrow-right {
    visibility: hidden;
  }

  ::v-deep .device_btn {
    button {
      width: 75px!important;
      height: 32px;
      padding: 0;
      text-align: center;
      line-height: 32px;
      max-width: 80px;
    }

    .is-disabled.gray {
      background: #444;
      color: #252525;
    }

    .takeButtonModule {
      float: none !important;
    }
  }

  ::v-deep .expend_box {
    height: 513px;
    border-bottom: 1px solid #333;
  }

  ::v-deep .title_icon_more {
    div {
      padding: 0;
    }
  }

  ::v-deep .el-select {
    .el-input {
      .el-input__inner {
        border-radius: 4px;
        border: 1px solid #444;
        background: #252525!important;
        &::-webkit-input-placeholder {
          color: #666;
        }
      }
      &.is-disabled .el-input__inner {
        background: #252525;
        color: #666!important;
        &::-webkit-input-placeholder {
          color: #444;
        }
      }
    }
  }

  .el-button--danger {
    background: #eb4040;
    border-color: #eb4040;
  }

  .title_select {
    .el-icon-more {
      transform: rotate(-90deg);
      color: #666;
    }

    ::v-deep .el-dropdown {
      float: right;
    }
  }
  /* WR-323: Live 源 R 关预览时列表缩略图仅居中显示隐藏预览图标 [Claude Code] */
  .live-preview-disabled-hint {
    height: 64px;
    width: 114px;
    position: absolute;
    top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #2F3330;
    color: #8c8c8c;
    .lpd-icon {
      font-size: 28px; /* 字体图标不吃宽高，改用 font-size [Claude Code] */
      cursor: pointer;
    }
  }
  .thumbnailIconBox {
    height: 64px;
    width: 114px;
    background: #000;
    text-align: center;
    line-height: 64px;
    position: absolute;
    top: 12px;
    span.iconfont {
      font-size: 12px;
      color: #b54a4a;
    }
    &.offline {
      background: #2f3330;
      cursor: no-drop;
      span.iconfont {
        color: #858585;
        cursor: no-drop;
      }
    }
    svg.svg-icon {
      height: 14px;
      width: 100%;
      margin: auto;
    }
  }
  .thumbnail_img {
    width: 114px;
    height: 64px;
    aspect-ratio: 16/9;
    padding: 0;
    border: none;
    margin: 12px 0;
    background: #252525;
  }
  .status.green:before {
    background: #33ab4f;
  }

  .status.red:before {
    background: #eb4040;
  }

  .status:before {
    content: '';
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background: #333;
    margin-right: 5px;
  }

  ::v-deep .el-table th,
  ::v-deep .el-table tr .el-table__expanded-cell {
    background: #252525 !important;
    padding: 0;
  }

  .bookmark_name {
    text-decoration: underline;
  }

  .video_detail:before {
    content: '\e78f';
    position: absolute;
    top: -20px;
    left: 50%;
  }

  .video_detail.show {
    opacity: 1;
    position: relative;
    z-index: 100;
    background: #111;
    margin-top: 15px;
    // margin-top: -100px;
    margin-bottom: 18px;
    padding: 0 20px;
  }

  .video_detail {
    font-family: element-icons !important;
    background: rgba(1, 1, 1, 0.5);
    // height: 520px;
    opacity: 0;
    width: 100%;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.56);
    border-radius: 8px;
    color: rgba(1, 1, 1, 0.5);
    font-size: 28px;
    transition: all 0.5s ease;

    ::v-deep .infoBox {
      font-size: 14px;
      color: #dbdbdb;
    }

    // ::v-deep .voiceModule {
    //   height: 423px;
    // }

    ::v-deep .vidoeModule {
      // margin-right: 25px;
    }

    ::v-deep .delayBitrateModule {
      // width: 20%;
      // margin-left: 0;
      // max-width: 360px;
      width: 360px;
    }

    ::v-deep .DetailModule {
      // width: auto;
      // margin-left: 0;
      width: 500px;

      // .live_info {
      //   width: 4rem !important;
      // }
    }
  }

  ::v-deep .column_r .cell {
    overflow: visible;
  }

  .r_box {
    ::v-deep .el-input {
      height: 32px;
      line-height: 32px;
    }

    ::v-deep .arrow-icon {
      position: absolute;
      bottom: 50%;
      transform: translateY(50%);
    }
  }

  ::v-deep .down_box.right_side .down_triangle:after {
    content: '\e791';
  }

  ::v-deep .down_box.top_side .down_triangle:after {
    content: '\e78f';
  }

  ::v-deep .down_box.right_side .edit_box {
    left: 74px;
    top: 6px;
  }

  ::v-deep .down_box.top_side .edit_box {
    left: 0;
    top: -50px;
  }

  ::v-deep .down_box {
    overflow: visible !important;

    .down_triangle {
      font-family: element-icons !important;

      span {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
      }

      cursor: pointer;
    }

    .down_triangle:after {
      content: '\e790';
    }

    .edit_box {
      position: absolute;
      left: 0;
      top: 60px;
      width: 160px;
      height: 71px;
      display: none;
      z-index: 200;
      background: rgba(27, 27, 27, 1);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      border-radius: 4px;

      .seleType {
        line-height: 18px;
        margin: 5px 10px;

        .cbr,
        .vbr {
          cursor: pointer;
          margin-right: 5px;
        }

        .dmc,
        .fixd {
          cursor: pointer;
          margin-right: 5px;
        }

        .greenCol {
          color: #33ab4f;
        }
      }

      .edit_bit {
        width: 80px;
        height: 26px;
        border-radius: 2px;
        border: 1px solid rgba(102, 102, 102, 1);
        background: none;
        outline: none;
        color: #dbdbdb;
      }

      .edit_bit:focus {
        border: 1px solid #252525;
      }

      .edit_delay {
        width: 80px;
        height: 26px;
        border-radius: 2px;
        border: 1px solid rgba(102, 102, 102, 1);
        background: none;
        outline: none;
        color: #dbdbdb;
      }

      .edit_delay:focus {
        border: 1px solid #252525;
      }
    }

    p {
      float: left;
    }
  }

  .greenInfo {
    color: #33ab4f;
  }
}
/* 添加骨架屏样式 */
::v-deep .el-table__placeholder {
  background: #333;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 0.3; }
  100% { opacity: 0.6; }
}
.battery1-box,
.battery2-box {
  width: 35%;
  text-indent: 12px;
  /*padding: 0 2%;*/
  padding: 0;
  margin-top: 20px;
  line-height: 50px;
}
.battery1-box {
  width: 100%;
}

.battery-moudel {
  border: 1px solid #5cb85c;
  height: 14px;
  width: 70%;
  padding: 2px 2px;
  position: relative;
}

.battery1-box .battery-moudel {
  margin-left: 3px;
  width: 20px;
  margin-top: 17px;
}

.battery-dot {
  position: absolute;
  top: 3px;
  right: -5px;
  border: 1px solid #5cb85c;
  border-left: 0px;
  height: 5px;
  width: 4px;
}

.battery1-value,
.battery2-value {
  display: block;
  background: #5cb85c;
  height: 8px;
  width: 70%;
}

.batterySpan {
  /*display: inline-block;*/
  width: 45px;
  margin-left: -6px;
  padding: 0;
  font-size: 14px;
}
</style>
<style lang="less">
.devicelist_title_list {
  width: 176px;
  height: 266px;
  font-size: 14px;
  color: #dbdbdb;
  background: rgba(27, 27, 27, 1);
  border-radius: 4px;
  border: none;

  li {
    height: 30px;
    line-height: 30px;
    padding: 0;

    .el-checkbox {
      width: 100%;
      left: 0;
      padding-left: 32px;
      padding-right: 5px;
      margin: 0;
    }
  }
}
/* WR-323: 缩略图禁用提示 hover 浮层——限宽换行 [Claude Code] */
.live-preview-tip.el-tooltip__popper {
  max-width: 240px;
  white-space: normal;
  word-break: normal;
  line-height: 1.5;
  text-align: left;
}
</style>
